import TransportationPermission from '@/components/Passenger/models/TransportationPermission';
import DestinationRole, { PermissionEnum } from './DestinationRole'
import { PassengerGroup } from './PassengerGroup';
import { PassengerGroupUserRole } from './PassengerGroupUseRole';

export enum PassengerGroupPermissionType {
    passengerPermission,
    transportationPermission,
}

export class User {
    id: string
    email: string;
    destinationRoles: DestinationRole[];
    passengerGroupRoles: PassengerGroupUserRole[];
    organizationIds?: string[];

    public hasPermissions(destinationId: number, permissions: number[]): boolean {
        const hasDestinationPermissions = this.destinationRoles.find(dr =>
            dr.destinationId === destinationId &&
            permissions.every(p => dr.permissions.includes(p))
        )
            ? true
            : false;
        return hasDestinationPermissions
    }

    // tslint:disable-next-line:max-line-length
    public hasPassengerGroupPermission(passengerGroupIds: number[], permissionType: PassengerGroupPermissionType, permission: PermissionEnum): boolean {
        const ids = passengerGroupIds;
        const passengerGroups = this.passengerGroupRoles.filter(p => ids.includes(p.passengerGroupId));
        if (!this.passengerGroupRoles.some(p => ids.includes(p.passengerGroupId)) || passengerGroups.length < 1) {
            return false;
        }

        if (permissionType === PassengerGroupPermissionType.passengerPermission) {
            if (permission === PermissionEnum.Write) {
                return passengerGroups.some(p => p.passengerPermission === PermissionEnum.Write);
            } else {
                return  passengerGroups.some(p => p.passengerPermission === PermissionEnum.Read);
            }
        } else if (permissionType === PassengerGroupPermissionType.transportationPermission) {
            if (permission === PermissionEnum.Write) {
                return passengerGroups.some(p => p.transportationPermission === PermissionEnum.Write);
            } else {
                return passengerGroups.some(p => p.transportationPermission === PermissionEnum.Read);
            }
        }
        return false;
    }

    public static fromApi(apiUser: any): User {
        const user = new User();
        user.id = apiUser.id;
        user.email = apiUser.email;
        user.destinationRoles = apiUser.destinationRoles
            ? apiUser.destinationRoles.map((dr: any) => DestinationRole.fromApi(dr))
            : [];
        user.passengerGroupRoles = apiUser.organizationPassengerGroupsRoles
            ? apiUser.organizationPassengerGroupsRoles.map((ur: any) => PassengerGroupUserRole.fromApi(ur))
            : [];
        user.organizationIds = apiUser.organizationIds;
        return user;
    }

}

export default User;
